import React, { useState } from "react";
import { AdminSidebar } from "../Sidebar/Sidebar";
import { AdminTopBar } from "../topbar/Topbar";
import "../Quest/Quests.css";
import "../toggle.css";
import { Link, useParams } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import ApprovePaymentModal from "./ApprovePaymentModal";
import RejectPaymentModal from "./RejectPaymentModal";
import { useViewSingleInvoicePayment } from "../../../../hooks/admin/InvoicePayments/useViewInvoicePayment";
import { useApprovePayment } from "../../../../hooks/admin/InvoicePayments/useApprovePayment";
import { useRejectPayment } from "../../../../hooks/admin/InvoicePayments/useRejectPayment";

export const AdminViewInvoicePayment = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);
  const { paymentId } = useParams();
  const { payment, loading, error, refetch } =
    useViewSingleInvoicePayment(paymentId);

  const {
    approvePayment,
    loading: approveLoading,
    error: approveError,
  } = useApprovePayment();

  const {
    rejectPayment,
    loading: rejectLoading,
    error: rejectError,
  } = useRejectPayment();

  const isApproved = payment?.status === "paid";
  const isRejected = payment?.status === "failed";

  const handleApprove = async () => {
    try {
      await approvePayment(payment?.id); // API call

      refetch(); // refresh payment data
      setShowApproveModal(false); // close modal after success
    } catch (err) {
      console.error(err);
    }
  };

  const handleReject = async ({ reason, remarks }) => {
    try {
      await rejectPayment(payment.id, { reason, remarks });
      setShowRejectModal(false);
      refetch();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="dashboardBody">
      <AdminSidebar isSidebarCollapsed={isSidebarCollapsed} />

      <div className="container-fluid p-0">
        <div id="mainContent">
          <AdminTopBar toggleSidebar={toggleSidebar} />

          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4 align-items-center">
                  <div className="col-12">
                    <BackButton />
                  </div>

                  <div className="col-md-6 my-4">
                    <p className="tchrdashboard-cmntitl mb-0">VIEW PAYMENT</p>
                  </div>

                  <div className="col-md-6 text-md-end my-4">
                    <Link
                      to="/school/agreement/create-payment"
                      className="add-school-btn"
                    >
                      <i className="fa fa-plus" aria-hidden="true"></i> Create
                      Payment
                    </Link>
                  </div>
                </div>

                {loading ? (
                  <div>
                    <p className="text-center justify-between">
                      Pls Wait We Are Loading Payment Detail...
                    </p>
                  </div>
                ) : (
                  <div className="row">
                    <hr />

                    <div className="d-flex justify-content-end mt-3">
                      {isApproved && (
                        <span className="badge bg-success px-4 py-2 rounded-pill">
                          <i className="fa fa-check me-2"></i> Approved
                        </span>
                      )}

                      {isRejected && (
                        <span className="badge bg-danger px-4 py-2 rounded-pill">
                          <i className="fa fa-times me-2"></i> Rejected
                        </span>
                      )}

                      {!isApproved && !isRejected && (
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-success px-4"
                            onClick={() => setShowApproveModal(true)}
                            disabled={approveLoading}
                          >
                            <i className="fa fa-check me-2"></i>
                            {approveLoading
                              ? "Approving..."
                              : "Approve Payment"}
                          </button>

                          <button
                            className="btn btn-danger px-4"
                            onClick={() => setShowRejectModal(true)}
                          >
                            <i className="fa fa-times me-2"></i> Reject
                          </button>
                        </div>
                      )}
                    </div>

                    {/* ===== Payment Summary ===== */}

                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-sm border-0 h-100">
                        <div className="card-header bg-white fw-bold">
                          Payment Details
                        </div>

                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Amount</span>
                            <h5 className="mb-0 text-success">
                              {payment?.currency === "INR" ? "₹" : "$"} {payment?.amount}
                            </h5>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Status</span>
                            <span className="badge bg-warning text-dark px-3 py-2 rounded-pill">
                              {payment?.status}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Payment Method</span>
                            <span>
                              {payment?.method
                                ?.split("_")
                                .map(
                                  (w) => w.charAt(0).toUpperCase() + w.slice(1)
                                )
                                .join(" ")}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Source</span>
                            <span>
                              {payment?.source?.charAt(0).toUpperCase() +
                                payment?.source?.slice(1)}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Reference ID</span>
                            <span className="fw-semibold">
                              {payment?.reference_id}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Verified</span>
                            {payment?.is_verified ? (
                              <span className="badge bg-success rounded-pill px-3 py-2">
                                Verified
                              </span>
                            ) : (
                              <span className="badge bg-danger rounded-pill px-3 py-2">
                                Not Verified
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ===== Invoice Details ===== */}
                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-sm border-0 h-100">
                        <div className="card-header bg-white fw-bold">
                          Invoice Details
                        </div>

                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Invoice No</span>
                            <span className="fw-semibold">
                              {payment?.invoice?.invoice_no}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Total Amount</span>
                            <span>{payment?.currency === "INR" ? "₹" : "$"}{" "} {payment?.invoice?.total_amount || "-"}</span>
                          </div>

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Paid Amount</span>
                            <span>{payment?.currency === "INR" ? "₹" : "$"}{" "} {payment?.invoice?.paid_amount || "-"}</span>
                          </div>

                          {/* <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Invoice Status</span>
                            <span className="badge bg-info rounded-pill px-3 py-2">
                              {payment?.invoice?.status}
                            </span>
                          </div> */}

                          <div className="d-flex justify-content-between mb-3">
                            <span className="text-muted">Issued At</span>
                            <span>
                              {payment?.invoice?.issued_at
                                ? new Date(
                                    payment.invoice.issued_at
                                  ).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                : "-"}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Due Date</span>
                            <span className="text-danger fw-semibold">
                              {payment?.invoice?.due_at
                                ? new Date(
                                    payment.invoice.due_at
                                  ).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ===== Proof Images ===== */}

                    {payment?.proofs?.length > 0 && (
                      <div className="col-12">
                        <div className="card shadow-sm border-0">
                          <div className="card-header bg-white fw-bold">
                            Payment Proofs
                          </div>

                          <div className="card-body">
                            <div className="row g-3">
                              {payment?.proofs.map((p) => (
                                <div className="col-md-3 col-sm-6">
                                  <a
                                    href={p?.url}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img
                                      key={p?.id}
                                      src={p?.url}
                                      alt="proof"
                                      className="img-fluid rounded shadow-sm"
                                      style={{
                                        height: "150px",
                                        objectFit: "cover",
                                        width: "100%",
                                      }}
                                    />
                                  </a>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {error && `Something Went Wrong. ${error}`}
              </div>
            </section>
          </div>
        </div>
      </div>

      <ApprovePaymentModal
        show={showApproveModal}
        onClose={() => setShowApproveModal(false)}
        amount={payment?.amount}
        invoiceNo={payment?.invoice?.invoice_no}
        loading={approveLoading}
        error={approveError}
        onConfirm={handleApprove}
      />

      <RejectPaymentModal
        show={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        loading={rejectLoading}
        error={rejectError}
        onConfirm={handleReject}
      />
    </div>
  );
};
